const stringToDateFormat = (dateString: string) => {
  const parts = dateString?.split('-');

  if (!parts) {
    return null;
  }

  if (parts.length === 3) {
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    const date = new Date(year, month, day);

    if (!isNaN(date.getTime())) {
      return date;
    }
  }

  return null;
};

export default stringToDateFormat;
